import React from "react"
import types from "prop-types"
import clsx from "clsx"
import CloseModalButton from "./CloseModalButton"

const ModalHeader = ({ closeModal = undefined, heading }) => (
  <div className={clsx(closeModal && "pt-10", "mb-8 relative")}>
    <span className="block text-center text-xl font-semibold">{heading}</span>
    {
      closeModal && (
        <CloseModalButton
          closeModal={closeModal}
          buttonLabel={`close ${heading} modal`}
        />
      )
    }
  </div>
)

ModalHeader.propTypes = {
  closeModal: types.func,
  heading: types.string.isRequired,
}

export default ModalHeader
